<template>
  <div id="tabContainer" class="app-main-content">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div v-show="isEdit">
          <el-button no="2" type="primary" :disabled="isAutoLoad" @click="autoLoadHandler">{{ $t('SeaExport.AutoAllocation') }}</el-button>
          <el-button no="3" type="primary" :disabled="selectedContainerUsage === null" @click="autoUnloadHandler">
            {{ $t('SeaExport.CleanOutTheLoadingRecord') }}
          </el-button>
          <el-button v-if="false" no="5" type="primary" @click="downTemplateBtn_clickHandler">
            {{ $t('SeaExport.TemplateDownload') }}
          </el-button>
          <el-upload
            v-if="false"
            action="string"
            :http-request="importExcelEventHandler"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUploadUsage"
            style="display: inline-block;padding-left: 5px;"
          >
            <el-button v-show="isEdit" type="primary">{{ $t('SeaExport.ExcelImport') }}</el-button>
          </el-upload>
        </div>
        <div>
          <span>
            {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
            {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
          </span>
        </div>
      </div>
    </div>
    <cargo-ag-grid
      config-module="130150"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="unitLoadDeviceUsages"
      :wrap-text="true"
      style="width:100%;height:100%"
      @gridReady="params=>gridApi=params.api"
    />
  </div>
</template>

<script>
import URL from '@/api/urlTranslator'

import { Job } from '@/class/model/booking/Job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
import { UnitLoadDeviceUtil } from '@/class/cargo/model/utils/UnitLoadDeviceUtil'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { TabError } from '@/utils/class/TabError'
import { sortByMultiField } from '@/utils'
import {
  importExcelData
} from '@/api/seaExport/containerUsage'
import lodash from 'lodash'
import { formatNumberToThousands } from '@/utils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import CargoAgGridDateTimeEditor from '@/components/Cargo/Common/CargoAgGridDateTimeEditor'
import TabContainerRecordLinkDialog from '@/components/Cargo/Job/tabContainerRecordLinkDialog'
import BoxInformationVerification from '../../../../../views/cargo/v0/SeaExport/components/booking/tabs/TabDataTracking/components/boxInformationVerification'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'

export default {
  name: 'TabUnitLoadDevice',
  components: { TabContainerRecordLinkDialog, BoxInformationVerification },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      contentShow: true,
      container: {
        basicTab: []
      },
      dialogVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridDateTimeEditor
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onRowClicked: this.itemClickHandler,
        onRowDragEnd: this.onRowDragEnd
      },
      gridApi: null,
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      dgContainerEditable: false, // 列表是否允许编辑
      job: new Job().fillDefaultValue().getData(),
      unitLoadDeviceUsages: [], // 装箱列表数据List
      selectedContainerUsage: null,
      isFCL: false, //  是否为整箱
      isUpdateCargoDoc: false, // 修改了件毛体则为true,作用是同步了件毛体信息需要参与入库修改
      isTabBasic: true, // CARGO-7908 (cargo 中在bookingworkspace 中设置的是true)
      isAutoLoad: false,
      isEditGoods: false, // 控制货物信息
      selection: []
    }
  },
  computed: {
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    isSlaveJob() {
      return this.job.lclMasterUuid
    },
    user() {
      return this.context.user || {}
    },
    columnDefs() {
      if (this.job.lclMasterUuid) {
        return [
          {
            headerName: '',
            colId: 'serialNo',
            field: '',
            width: 60,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            lockVisible: true,
            wrapText: false // 去除因拖拽而导致的行自动撑高
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerType'),
            colId: 'containerType',
            field: 'containerType',
            width: 100,
            valueFormatter: params => {
              return CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerCode'),
            colId: 'containerCode',
            field: 'containerCode',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerNumber'),
            colId: 'containerNumber',
            field: 'containerNumber',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.cargo_pallet'),
            colId: 'board',
            field: 'board',
            width: 100,
            valueFormatter: params => ColumnUtils.booleanLabelFunction(params.value)
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.OnBoardRequirements'),
            colId: 'loadReq',
            field: 'loadReq',
            width: 120,
            valueFormatter: params => this.job.loadReq || ''
          },
          {
            headerName: this.$t('SeaExport.SpaceRquirement'),
            colId: 'cabinReq',
            field: 'cabinReq',
            width: 120,
            valueFormatter: params => this.job.cabinReq || ''
          },
          {
            headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
            colId: 'cargoChineseName',
            field: 'cargoChineseName',
            width: 120,
            valueFormatter: params => this.job.cargoChineseName || ''
          },
          {
            headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
            colId: 'cargoEnglishName',
            field: 'cargoEnglishName',
            width: 120,
            valueFormatter: params => this.job.cargoEnglishName || ''
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            colId: 'mark',
            field: 'mark',
            width: 100,
            valueFormatter: params => this.job.mark || ''
          },
          {
            headerName: 'HSCODE',
            colId: 'hsCode',
            field: 'hsCode',
            width: 120,
            valueFormatter: params => this.job.hsCode || ''
          }
        ]
      }
      const defs =
        [
          {
            headerName: '',
            colId: 'serialNo',
            field: '',
            width: 60,
            rowDrag: this.dgContainerEditable && this.isEdit && !this.isSlaveJob,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            lockVisible: true,
            wrapText: false // 去除因拖拽而导致的行自动撑高
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerType'),
            colId: 'containerType',
            field: 'containerType',
            width: 100,
            valueFormatter: params => {
              return CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerCode'),
            colId: 'containerCode',
            field: 'containerCode',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ApplicableContainerNumber'),
            colId: 'containerNumber',
            field: 'containerNumber',
            editable: this.isEdit && !this.isSlaveJob,
            cellEditor: 'CargoAgGridCommonInputEditor',
            width: 100,
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('CargoMsg.cargo_pallet'),
            colId: 'board',
            field: 'board',
            width: 100,
            valueFormatter: params => ColumnUtils.booleanLabelFunction(params.value)
          },
          {
            headerName: this.$t('CargoMsg.cargo_container_max_weight') + '（KG）',
            colId: 'cargoWeight',
            field: 'cargoWeight',
            width: 100,
            valueFormatter: params => {
              const data = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirplaneContainer, 'code', params.data.containerCode, 'cargoWeight')
              params.data.cargoWeight = data
              return data
            }
          },
          {
            headerName: this.$t('CargoMsg.cargo_container_max_capacity') + '（m³）',
            colId: 'cargoCapacity',
            field: 'cargoCapacity',
            width: 100,
            valueFormatter: params => {
              const data = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirplaneContainer, 'code', params.data.containerCode, 'cargoCapacity')
              params.data.cargoCapacity = data
              return data
            }
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true)),
            editable: this.isEdit && !this.isSlaveJob,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.isEdit && !this.isSlaveJob,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              }
            },
            cellStyle: params => {
              return (params.data.weight > params.data.cargoWeight) ? { color: 'red' } : { color: 'black' }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
            editable: this.isEdit && !this.isSlaveJob,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3
              }
            },
            cellStyle: params => {
              return (params.data.cubage > params.data.cargoCapacity) ? { color: 'red' } : { color: 'black' }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('SeaExport.OnBoardRequirements'),
            colId: 'loadReq',
            field: 'loadReq',
            width: 120,
            valueFormatter: params => this.job.loadReq || ''
          },
          {
            headerName: this.$t('SeaExport.SpaceRquirement'),
            colId: 'cabinReq',
            field: 'cabinReq',
            width: 120,
            valueFormatter: params => this.job.cabinReq || ''
          },
          {
            headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
            colId: 'cargoChineseName',
            field: 'cargoChineseName',
            width: 120,
            valueFormatter: params => this.job.cargoChineseName || ''
          },
          {
            headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
            colId: 'cargoEnglishName',
            field: 'cargoEnglishName',
            width: 120,
            valueFormatter: params => this.job.cargoEnglishName || ''
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            colId: 'mark',
            field: 'mark',
            width: 100,
            valueFormatter: params => this.job.mark || ''
          },
          {
            headerName: 'HSCODE',
            colId: 'hsCode',
            field: 'hsCode',
            width: 120,
            valueFormatter: params => this.job.hsCode || ''
          }
        ]
      return defs
    },
    config() {
      return this.context.config
    },
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.dialogVisible = false
      this.job = row
      this.selection = []
      this.isAutoLoad = false
      await this.jobChanged()
    },
    // 计算重复箱子数量
    counterArray(arr) {
      var obj = {}
      console.log('arr=====', arr)
      arr.forEach(function(v, k) {
        if (obj[v]) {
          obj[v]++
        } else {
          obj[v] = 1
        }
      })
      return obj
    },
    // 锦昶专用，当箱货信息清空时，对应的装箱和装箱明细也要清空
    clearContainer(row) {
      if ((!row.airUld || row.airUld.length <= 0) && !row.masterFlag) {
        this.unitLoadDeviceUsages = []
      }
    },
    endTabHandler() {
      this.fillModel()
    },
    async jobChanged() {
      if (!this.job) return

      const job = new AirExportJob(this.job)
      await Promise.all([
        job.getLclMaster(),
        job.getAirUld(),
        job.getUnitLoadDeviceUsages(),
        job.getUnitLoadDevices()
      ])
      // 锦昶专用，当箱货信息清空时，对应的装箱和装箱明细也要清空
      this.clearContainer(job)

      await this.jobLoadResultHandler()

      // lcl 小票 通过 usage 关联出unitLoadDevice
      if (job.lclMasterUuid) {
        const ctnr = []
        for (const item of job.unitLoadDeviceUsages) {
          ctnr.push(item.unitLoadDevice)
        }
        if (!job.unitLoadDevices) {
          job.unitLoadDevices = []
        }
        job.unitLoadDevices.splice(0, job.unitLoadDevices.length, ...ctnr)
      }
      // 组装 unitLoadDevices.unitLoadDeviceUsage  同 job.unitLoadDeviceUsages 指向同一usage
      await UnitLoadDeviceUtil.buildUnitLoadDeviceUsages(this.job)

      const unitLoadDeviceUsages = this.job.unitLoadDeviceUsages.sort((a, b) => {
        return a.serialNo - b.serialNo
      })
      console.info('unitLoadDeviceUsages', unitLoadDeviceUsages)
      this.unitLoadDeviceUsages = unitLoadDeviceUsages

      // 港区数据同步对比服务
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
        this.gridApi.refreshCells({ force: true })
      }
      this.refreshContainerWeight()
      this.refreshTotal()
    },

    async getSubmitData() {
      this.validate()
      this.fillModel()
      // 装箱件毛体 可能是从基本页签同步而来 没有触发cellChange 方法，同步箱子上的件毛体
      console.log('this.unitLoadDeviceUsages=======', this.unitLoadDeviceUsages)
      console.log('this.job=======', this.job)
      // todo 过滤 isDirty = true 提交至后端保存 待全局测试
      // 如果是新增箱子
      if (this.job.unitLoadDevices && this.job.unitLoadDevices.length > 0) {
        this.job.unitLoadDevices.forEach(p => {
          if (!p.uuid) {
            if (p.unitLoadDeviceUsages && p.unitLoadDeviceUsages.length > 0) {
              this.p.unitLoadDeviceUsage = p.unitLoadDeviceUsages
            }
            delete p.unitLoadDeviceUsages
          }
        })
      }
      let checkWeightOrCubage = false
      if (this.job.unitLoadDeviceUsages && this.job.unitLoadDeviceUsages.length > 0) {
        for (const p of this.job.unitLoadDeviceUsages) {
          // 校验重量、体积是否大于集装器可装货体积、重量
          // 获取集装器信息
          const containerCode = p.containerCode
          const item = getObjectByCache(basicCacheKeys.basic_data_AirplaneContainer, 'code', containerCode)
          if (item) {
            const names = []
            if (item.cargoWeight < p.weight) {
              names.push(this.$t('CargoMsg.Cargo_Weight'))
            }
            if (item.cargoCapacity < p.cubage) {
              names.push(this.$t('CargoMsg.Cargo_Cubage'))
            }
            if (names.length > 0) {
              await this.$confirm(this.$t('CargoMsg.Cargo_CheckUldWeightOrCubage', [containerCode, names.join('/'), names.join('/')]),
                this.$t('Message.Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_No'),
                  type: 'warning'
                }).then(() => {
                checkWeightOrCubage = true
              }).catch(() => {
                p.weight = 0.0
                p.cubage = 0.0
                checkWeightOrCubage = false
              })
              if (!checkWeightOrCubage) {
                this.gridApi.refreshCells({ force: true })
                throw new TabError('', 'tabUnitLoadDevice')
              }
            }
          }
          if (p.uuid && p.unitLoadDevice) {
            if (p.unitLoadDevice.unitLoadDeviceUsages === '') {
              p.unitLoadDevice.unitLoadDeviceUsages = []
            }
            if (p.unitLoadDevice.unitLoadDeviceUsage === '') {
              p.unitLoadDevice.unitLoadDeviceUsage = []
            }
          }
        }
      }
      const job = { ...this.job }
      const result = {
        job, // 未打开过时 件毛体同步数据需要保存
        unitLoadDeviceUsages: this.unitLoadDeviceUsages.filter(p => !StrUtils.isEmpty(p.uuid)),
        unitLoadDevices: this.job.unitLoadDevices.filter(p => p.isDirty === true),
        delUnitLoadDeviceUuids: this.job.delUnitLoadDeviceUuids // 删除的箱子uuid
      }
      // 修改件毛体
      if (this.job.airUld && this.job.airUld.length > 0) {
        result['airUld'] = this.job.airUld.filter(p => p.isDirty === true)
      }
      return result
    },
    fillModel() {
    },
    /**
     * 验证
     */
    validate() {
      if (!this.job || !this.job.unitLoadDeviceUsages || !this.isEdit) {
        return true
      }
      const msg = UnitLoadDeviceUtil.validateContainerUsage(this.job)
      if (msg) {
        throw new TabError(msg, 'tabUnitLoadDevice')
      }
      return true
    },
    async jobLoadResultHandler() {
      // 根据箱型初始化箱子(待审核的时候不允许看到装箱信息)
      if (this.job.jobState > SystemConstants.PENDING) {
        await UnitLoadDeviceUtil.autoJustUnitLoadDeviceUsages(this.job, this.action, false)
      }

      // 避免 JSON 对象的循环引用  sortByMultiField 报错 ，后端排序
      // this.job.unitLoadDeviceUsages = this.sortByOrder(this.job.unitLoadDeviceUsages)

      this.selectedContainerUsage = null
    },
    // 按照指定字段排序
    sortByOrder(categoryArray) {
      if (categoryArray == null || categoryArray.length === 0) {
        return null
      } else {
        categoryArray = sortByMultiField(categoryArray, ['dateCreated'], false)
      }
      return categoryArray
    },
    refreshContainerWeight() {
      for (const usage of this.unitLoadDeviceUsages) {
        if (usage.unitLoadDevice) {
          // 列显示 箱子相关信息 移至 usage
          usage.containerType = usage.unitLoadDevice.containerType
          usage.containerCode = usage.unitLoadDevice.containerCode
          usage.containerNumber = usage.unitLoadDevice.containerNumber
        }
      }
    },
    refreshTotal() {
      let quantity = 0
      let weight = 0
      let cubage = 0

      for (const usage of this.job.unitLoadDeviceUsages) {
        if (usage.deleted) {
          continue
        }
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = UnitLoadDeviceUtil.getContainerDesc(this.job)
    },
    // 行选择事件
    itemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectedContainerUsage = event.data
      this.isEditGoods = true
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedContainerUsage = node.data
          }
        })
      }
    },
    // 列编辑修改事件 (gridEditSaveHandler)
    async onCellChange(params) {
      console.log('-----cellChange-------', params)
      console.log('-----cellChange params.field-------', params.field)
      const _job = this.job
      const usage = params.data
      if (!usage) {
        return
      }
      // 列编辑时 usage.unitLoadDevice 没了，所以加了如下方法重新赋值
      if (usage && !usage.unitLoadDevice && this.job.unitLoadDevices && this.job.unitLoadDevices.length > 0) {
        for (const unitLoadDevice of this.job.unitLoadDevices) {
          if (StrUtils.isEmpty(unitLoadDevice.uuid)) continue
          if (usage.unitLoadDeviceUuid === unitLoadDevice.uuid) {
            usage.unitLoadDevice = unitLoadDevice
          }
          if (unitLoadDevice.unitLoadDeviceUsage) {
            for (let oldUsage of unitLoadDevice.unitLoadDeviceUsage) {
              if (usage.uuid === oldUsage.uuid) {
                oldUsage = usage
              }
            }
          }
        }
      }
      usage.unitLoadDevice.isDirty = true
      const key = params.field || params.colDef.colId
      switch (key) {
        case 'containerNumber':
          usage.unitLoadDevice.containerNumber = usage.containerNumber
          break
        case 'quantity' :
          // 用删除的方式 内容是空 保存null 会报错
          if (!usage.quantity) {
            usage.quantity = 0
          }
          // h5 不需要 quantityChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC('quantityContract')
            this.refreshQWC()
            if (usage.unitLoadDevice) {
              usage.unitLoadDevice.quantity = usage.quantity
            }
          }
          usage.isDirty = true
          break
        case 'weight' :
          if (!usage.weight) {
            usage.weight = 0
          }
          // h5 不需要  weightChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC('weightContract')
            this.refreshQWC()
            if (usage.unitLoadDevice) {
              usage.unitLoadDevice.weight = usage.weight
            }
          }
          break
        case 'cubage' :
          if (!usage.cubage) {
            usage.cubage = 0
          }
          // h5 不需要  cubageChange(usage, event);
          if (_job && _job.lob === SystemConstants.SE.code) {
            this.updateJobActualQWC('cubageContract')
            this.refreshQWC()
            if (usage.unitLoadDevice) {
              usage.unitLoadDevice.cubage = usage.cubage
            }
          }
          break
        default :
          break
      }
      if (this.gridApi) this.gridApi.refreshCells({ force: true })
    },
    /**
     * 计算件毛体总数
     */
    refreshQWC() {
      let quantity = 0
      let weight = 0
      let cubage = 0
      for (const usage of this.job.unitLoadDeviceUsages) {
        quantity += Number(usage.quantity) || 0
        if (!isNaN(usage.weight)) {
          weight += Number(usage.weight)
        }
        if (!isNaN(usage.cubage)) {
          cubage += Number(usage.cubage)
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
    },
    async updateJobActualQWC(contractField) {
      this.isUpdateCargoDoc = true
      await UnitLoadDeviceUtil.refContainerUsageQwc(this.job, 1)
      // CARGO-7908
      const expression = Number(this.config.get('ContainerUpdateJobQCW'))
      if (expression === 3 && this.isTabBasic) {
        await UnitLoadDeviceUtil.refContainerUsageQwc(this.job, 3)
      }
      const rule = Number(this.config.get('SEQuantityWeightCubageRule'))
      if (rule === 2) {
        UnitLoadDeviceUtil.refreshContainerUsageContractQwc(this.job, contractField)
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 自动装箱
    autoLoadHandler() {
      // 请在主票进行装板操作
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Please_Load_The_Main_Ticket'))
        return
      }
      UnitLoadDeviceUtil.autoLoadContainerUsage(this.job)
      // 设置更改标识
      for (const ctnr of this.job.unitLoadDevices) {
        ctnr.isDirty = true
      }
      this.gridApi.setRowData(this.job.unitLoadDeviceUsages)
      this.refreshTotal()
    },
    // 清空装箱记录
    autoUnloadHandler() {
      // 请在主票进行清空装板操作
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation'))
        return
      }
      const usage = this.selectedContainerUsage
      if (usage) {
        usage.unitLoadDevice.containerNumber = ''
        usage.weight = 0
        usage.quantity = 0
        usage.cubage = 0

        // 箱子信息列字段移至 usage
        usage.containerNumber = ''

        usage.unitLoadDevice.isDirty = true
        usage.isDirty = true
      }
      this.gridOptions.api.applyTransaction({ update: [usage] })
      this.refreshTotal()
    },
    // 删除装箱记录
    deleteContainerHandler() {
      const items = this.gridApi.getSelectedRows()
      if (items.length === 0) {
        return
      }
      for (const usage of items) {
        //  记录删除的 箱子uuid  此处记录到job 字段属性上
        if (!StrUtils.isEmpty(usage.uuid)) {
          if (!this.job.delContainerUuids) {
            this.job.delContainerUuids = []
          }
          this.job.delContainerUuids.push(usage.unitLoadDeviceUuid)
        }
        const index = this.unitLoadDeviceUsages.findIndex(p => p === usage)
        this.unitLoadDeviceUsages.splice(index, 1)
      }
      this.isEditGoods = false
      this.refreshTotal()
      this.gridApi.clearFocusedCell()
    },
    // 刷新
    async refresh() {
      if (this.job && !StrUtils.isEmpty(this.job.uuid)) {
        const job = new AirExportJob(this.job)
        job.airUld = ''
        job.unitLoadDevices = ''
        job.unitLoadDeviceUsages = ''
        await Promise.all([
          job.getAirUld(),
          job.getUnitLoadDeviceUsages(),
          job.getUnitLoadDevices()
        ])
        await this.jobChanged()
      }
    },
    // 模板下载
    downTemplateBtn_clickHandler() {
      const fileName = 'ContainerUsageImportTemplate.xls'
      const folderName = 'booking'
      ExportUtils.downloadTemplateFile(fileName, folderName)
    },
    beforeUploadUsage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    // excel导入
    importExcelEventHandler(item) {
      const usages = lodash.cloneDeep(this.job.unitLoadDeviceUsages)
      // 避免循环引用
      for (const usage of usages) {
        delete usage.unitLoadDevice.unitLoadDeviceUsage
      }

      const jobObj = { job: { lob: this.job.lob }, airUld: this.job.airUld, unitLoadDeviceUsages: usages }
      const params = {
        file: item.file,
        job: JSON.stringify(jobObj),
        jobUuid: this.job.uuid,
        jobNo: this.job.jobNo
      }
      importExcelData(params).then(response => {
        if (response.data == null || response.data === '') {
          this.$message.warning(this.$t('SeaExport.FileContentWrong'))
        } else {
          this.uploadSuccessUsage(response.data)
        }
      })
    },
    // excel导入 后数据处理 importFileHandler
    uploadSuccessUsage(data) {
      if (!data && !this.job) {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
        return
      }
      const usageCompare = []
      for (const usage of this.job.unitLoadDeviceUsages) {
        const oldContainer = usage.unitLoadDevice
        for (const newUsage of data.unitLoadDeviceUsages) {
          // 记录 已匹配的数据 如已参与比较不再 比对
          if (usageCompare.findIndex(p => p === newUsage) > -1) {
            continue
          }
          const newContainer = newUsage.unitLoadDevice
          if (oldContainer.eqSize === newContainer.eqSize && oldContainer.eqType === newContainer.eqType) {
            oldContainer.containerNumber = newContainer.containerNumber
            oldContainer.sealNo = newContainer.sealNo
            oldContainer.containerWeight = newContainer.containerWeight
            oldContainer.remark = newContainer.remark
            oldContainer.cargoName = newContainer.cargoName
            oldContainer.isDirty = true
            oldContainer.boxController = newContainer.boxController
            oldContainer.carNumber = newContainer.carNumber
            oldContainer.weight = newContainer.weight

            usage.containerNumber = newContainer.containerNumber
            usage.containerWeight = newContainer.containerWeight
            usage.sealNo = newContainer.sealNo
            usage.remark = newContainer.remark
            usage.cargoName = newContainer.cargoName

            usage.quantity = newUsage.quantity
            usage.weight = newUsage.weight
            usage.cubage = newUsage.cubage
            usage.hsCode = newUsage.hsCode
            usage.soc = newUsage.soc
            usage.isDirty = true
            usage.boxController = newContainer.boxController
            usage.carNumber = newContainer.carNumber

            usageCompare.push(newUsage)

            break
          }
        }
      }
      this.refreshTotal()
      this.gridApi.refreshCells({ force: true })
      this.gridApi.clearFocusedCell()
    },
    // 组装打印参数
    getPrintData() {
      const unitLoadDeviceUsages = this.gridApi.getSelectedRows()
      if (!unitLoadDeviceUsages || unitLoadDeviceUsages.length === 0) {
        this.$message.warning(this.$t('Message.NoSelectedContainerInformation'))
        return
      }
      const params = {}
      if (unitLoadDeviceUsages.length === 1) {
        params.CONTAINER_UUID = unitLoadDeviceUsages[0].unitLoadDevice.uuid
        params.category = 'FCL'
        params.ctx = new AirExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "FCL", params, this);
      } else {
        const uids = []
        for (const c of unitLoadDeviceUsages) {
          if (c.unitLoadDevice && c.unitLoadDevice.uuid && !uids.includes(c.unitLoadDevice.uuid)) {
            uids.push(c.unitLoadDevice.uuid)
          }
        }
        params.CONTAINER_UUID = uids
        params.category = 'CONTAINER_LIST'
        params.ctx = new AirExportJob(this.job)
        // TemplateSelectorWin.getInstance().showThisWin(job, "CONTAINER_LIST", params, this);
      }
      this.$logger.log('params', params)
      return params
    },
    handleChange(obj) {
      this.unitLoadDeviceUsages.forEach(eve => {
        if ((!StrUtils.isEmpty(obj.uuid) && eve.uuid === obj.uuid) ||
          (StrUtils.isEmpty(obj.uuid) && eve.containerNumber === obj.containerNumber)) {
          eve.quantity = obj.quantity
          eve.weight = obj.weight
          eve.cubage = obj.cubage
        }
      })
      this.gridApi.setRowData(this.unitLoadDeviceUsages)
      this.refreshQWC()
    },
    onRowDragEnd(params) {
      console.log('dragEnd', params)
      params.api.getModel().rowsToDisplay.forEach(node => {
        console.log(node)
        node.data.serialNo = node.rowIndex
        this.onCellChange({ data: node.data, colDef: { colId: 'serialNo' }})
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.app-main-content{
  .operations{
    .triggers{
      overflow: visible;
      div{
        .el-badge{
          margin: 0 0 3px 5px;
        }
      }
    }
  }
}
.portData-service{
  padding-top: 10px;
  & > i{
    margin-right: 5px;
    color: #409EFF;
    font-size: 30px;
    vertical-align: middle;
  }
  & > span{
    line-height: 32px;
    vertical-align: middle;
    font-weight: bold;
    font-size: 16px;
    display: inline-block;
  }
  & > p{
    padding: 10px 0 10px 35px;
    line-height: 22px;
    font-size: 14px;
  }
}
</style>
<style lang="scss">
#tabContainer {
  .el-dialog__wrapper{
    pointer-events: none;
  }
  .el-dialog{
    pointer-events: auto;
  }
}
</style>
